import React from 'react';
import { Link } from 'react-router-dom';
import { imgUrl } from '../lib/utils';

export const GameCard = ({ product }) => {
  const linkTo = product.source === 'digiflazz'
    ? `/product/${product.slug}`
    : `/product/${product.slug}`;

  return (
    <Link
      to={linkTo}
      className="group relative overflow-hidden bg-zinc-900/40 border border-zinc-800 hover:border-zinc-700 rounded-xl transition-all duration-200 block"
      data-testid={`game-card-${product.slug}`}
    >
      {/* Image Container with elegant ratio */}
      <div className="aspect-[4/3] w-full overflow-hidden bg-zinc-950 relative">
        <img
          src={imgUrl(product.image)}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-semibold text-white text-sm truncate group-hover:text-emerald-400 transition-colors">
          {product.name}
        </h3>
        {product.source === 'digiflazz' ? (
          <p className="text-xs text-emerald-400/90 mt-1 font-mono">
            {product.itemCount} channels · From Rp {product.startPrice?.toLocaleString('id-ID')}
          </p>
        ) : (
          <p className="text-xs text-zinc-400 capitalize mt-1 font-mono">
            {product.category}
          </p>
        )}
      </div>
    </Link>
  );
};

export const GameCardSkeleton = () => {
  return (
    <div className="bg-card border border-white/5 rounded-xl overflow-hidden">
      <div className="aspect-square skeleton" />
      <div className="p-3 space-y-2">
        <div className="h-4 skeleton rounded w-3/4" />
        <div className="h-3 skeleton rounded w-1/2" />
      </div>
    </div>
  );
};
